// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-list[data-v-2082da19]{height:150px;position:relative;border-radius:5px;overflow:hidden}.widget-list>.widget-list-title[data-v-2082da19]{line-height:40px;height:40px;background:rgba(0,0,0,.25);color:#fff;position:absolute;bottom:0;left:0;right:0;padding:0 15px}", ""]);
// Exports
module.exports = exports;
